/* Millennio — modal «Escribir reseña» de la PDP (módulo Reviews de la app Digitdeck).
   Contrato y por qué: cabecera de snippets/mi-resena-form.liquid.

   1. Lee el DTO público (`<proxy>/list?product_id=…`) en reposo y aplica lo que
      manda la app: política de campos, campos personalizados, fotos, recogida
      abierta. Si la app no recoge, los botones «Escribir reseña» desaparecen.
   2. Abre/cierra el <dialog> nativo (showModal: top layer; Esc lo cierra el
      navegador) con el bloqueo de scroll compartido del buscador.
   3. Envía multipart a `<proxy>/submit` con requestId UUID por intento.
   4. Éxito: esconde el form y enseña el bloque de gracias (la reseña nace
      pendiente; se ve cuando la tienda la aprueba en el panel). */
(function () {
  'use strict';
  if (window.__miResenaForm) return;
  window.__miResenaForm = true;

  var ESTRELLA = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M7 .6 8.51 4.93 13.09 5.02 9.44 7.79 10.76 12.18 7 9.56 3.24 12.18 4.57 7.79.91 5.02 5.5 4.93Z"/></svg>';
  var MAX_FOTOS = 3, MAX_FOTO_BYTES = 5 * 1024 * 1024;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16); });
  }

  /* Fila de estrellas: pinta hasta la elegida; hover previsualiza. */
  function estrellas(grupo) {
    var botones = Array.prototype.slice.call(grupo.querySelectorAll('.mi-rf__estrella'));
    var oculto = grupo.querySelector('input[type="hidden"]');
    var valorEl = grupo.parentElement && grupo.parentElement.querySelector('[data-mi-rf-extra-valor]');
    function pintar(n, clase) {
      botones.forEach(function (b) {
        var v = +b.getAttribute('data-mi-rf-valor');
        b.classList.toggle(clase, v <= n);
        if (clase === 'esta-llena') b.setAttribute('aria-checked', v === n ? 'true' : 'false');
      });
    }
    botones.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = +b.getAttribute('data-mi-rf-valor');
        var mismo = oculto.value === String(v);
        oculto.value = mismo ? '' : String(v); /* repetir la misma quita la nota: nunca se convierte ausencia en 0 */
        pintar(mismo ? 0 : v, 'esta-llena');
        if (valorEl) valorEl.textContent = mismo ? '' : v + '/5';
      });
      b.addEventListener('mouseenter', function () { pintar(+b.getAttribute('data-mi-rf-valor'), 'esta-previa'); });
    });
    grupo.addEventListener('mouseleave', function () { pintar(0, 'esta-previa'); });
  }

  function filaEstrellas(nombre, mini) {
    var html = '<div class="mi-rf__estrellas' + (mini ? ' mi-rf__estrellas--mini' : '') + '" role="radiogroup" data-mi-rf-estrellas>';
    for (var i = 1; i <= 5; i++) html += '<button type="button" class="mi-rf__estrella" role="radio" aria-checked="false" data-mi-rf-valor="' + i + '" aria-label="' + i + ' de 5"' + '>' + ESTRELLA + '</button>';
    return html + '<input type="hidden" name="' + esc(nombre) + '" value=""></div>';
  }

  /* Campos personalizados del DTO → marcado. Un tipo por rama; nada de fábrica. */
  function campoExtra(f) {
    var nombre = 'cf_' + f.key, req = f.required ? ' required' : '';
    var etq = '<span class="mi-rf__etq">' + esc(f.label) + (f.required ? ' <span class="mi-rf__req">*</span>' : '') + '</span>';
    if (f.type === 'rating') {
      return '<div class="mi-rf__extra" data-mi-rf-extra="' + esc(f.key) + '" data-mi-rf-requerido="' + (f.required ? '1' : '') + '">' + etq + '<span style="display:inline-flex;align-items:center;gap:8px">' + filaEstrellas(nombre, true) + '<span class="mi-rf__extra-valor" data-mi-rf-extra-valor></span></span></div>';
    }
    if (f.type === 'select') {
      return '<label class="mi-rf__campo">' + etq + '<select class="mi-rf__input mi-rf__select" name="' + esc(nombre) + '"' + req + '><option value="">Elige una opción</option>' + (f.options || []).map(function (o) { return '<option value="' + esc(o) + '">' + esc(o) + '</option>'; }).join('') + '</select></label>';
    }
    if (f.type === 'multiselect') {
      return '<fieldset class="mi-rf__campo mi-rf__recomienda"><legend class="mi-rf__etq">' + esc(f.label) + '</legend><div class="mi-rf__opciones">' + (f.options || []).map(function (o) { return '<label class="mi-rf__opcion"><input type="checkbox" name="' + esc(nombre) + '[]" value="' + esc(o) + '"> ' + esc(o) + '</label>'; }).join('') + '</div></fieldset>';
    }
    if (f.type === 'boolean') {
      return '<fieldset class="mi-rf__campo mi-rf__recomienda"><legend class="mi-rf__etq">' + esc(f.label) + '</legend><div class="mi-rf__opciones"><label class="mi-rf__opcion"><input type="radio" name="' + esc(nombre) + '" value="true"' + req + '> Sí</label><label class="mi-rf__opcion"><input type="radio" name="' + esc(nombre) + '" value="false"> No</label></div></fieldset>';
    }
    if (f.type === 'integer' || f.type === 'decimal') {
      var c = f.constraints || {};
      var min = c.min != null && c.min !== '' && Number.isFinite(Number(c.min)) ? Number(c.min) : null;
      var max = c.max != null && c.max !== '' && Number.isFinite(Number(c.max)) ? Number(c.max) : null;
      return '<label class="mi-rf__campo">' + etq + '<input class="mi-rf__input" type="number" name="' + esc(nombre) + '" step="' + (f.type === 'integer' ? '1' : 'any') + '"' + (min != null ? ' min="' + min + '"' : '') + (max != null ? ' max="' + max + '"' : '') + req + '></label>';
    }
    if (f.type === 'text') {
      return '<label class="mi-rf__campo">' + etq + '<input class="mi-rf__input" type="text" maxlength="200" name="' + esc(nombre) + '"' + req + '></label>';
    }
    /* ponytail: los campos de archivo personalizados (image/video/audio/file) no se pintan;
       Millennio no tiene ninguno. Si el panel añade uno, copiar el bloque de fotos. */
    return '';
  }

  function montar(raiz) {
    var form = raiz.querySelector('[data-mi-rf-form]');
    if (!form || raiz.__miMontado) return;
    raiz.__miMontado = true;
    var seccion = raiz.closest('[data-dd-component="mi-resenas"]') || document;
    var botones = seccion.querySelectorAll('[data-mi-rf-abrir]');
    var devolverFoco = null;

    /* --- 0. abrir / cerrar el <dialog> ------------------------------------- */
    function abrir(e) {
      if (e) e.preventDefault();
      devolverFoco = (e && e.currentTarget) || document.activeElement;
      cargar();
      if (typeof raiz.showModal === 'function') raiz.showModal(); else raiz.setAttribute('open', '');
      if (typeof window.miBloquearScroll === 'function') window.miBloquearScroll(true);
      /* El foco entra al panel, no a la primera estrella: así no aparece un
         anillo negro sobre una estrella vacía nada más abrir; Tab lleva al
         cierre y luego a los campos. */
      var panel = raiz.querySelector('[data-mi-rf-panel]');
      if (panel) panel.focus({ preventScroll: true });
      raiz.dispatchEvent(new CustomEvent('mi:resena:abierto', { bubbles: true }));
    }
    function cerrar() {
      if (raiz.open && typeof raiz.close === 'function') raiz.close(); else raiz.removeAttribute('open');
    }
    raiz.addEventListener('close', function () {
      if (typeof window.miBloquearScroll === 'function') window.miBloquearScroll(false);
      if (devolverFoco && typeof devolverFoco.focus === 'function') devolverFoco.focus({ preventScroll: true });
      raiz.dispatchEvent(new CustomEvent('mi:resena:cerrado', { bubbles: true }));
    });
    Array.prototype.forEach.call(botones, function (b) { b.addEventListener('click', abrir); });
    Array.prototype.forEach.call(raiz.querySelectorAll('[data-mi-rf-cerrar]'), function (b) { b.addEventListener('click', cerrar); });
    /* Clic en el velo (fuera del panel) cierra: el <dialog> ES el velo. */
    raiz.addEventListener('click', function (e) { if (e.target === raiz) cerrar(); });
    var base = raiz.getAttribute('data-proxy') || '/apps/back-in-stock/reviews';
    var estado = raiz.querySelector('[data-mi-rf-estado-msg]');
    var enviar = raiz.querySelector('[data-mi-rf-enviar]');
    var extras = raiz.querySelector('[data-mi-rf-extras]');
    var fotosInput = raiz.querySelector('[data-mi-rf-fotos]');
    var previas = raiz.querySelector('[data-mi-rf-previas]');
    var consent = raiz.querySelector('[data-mi-rf-consent]');
    var fotos = [];
    /* Sin DTO, el formulario es el que pintó Liquid (fotos y ejes incluidos):
       `media` arranca en true y `fields` en null = «no sustituyas los ejes». */
    var dto = { fields: null, formPolicy: null, fieldVersion: '', formPolicyVersion: '', media: true };
    var requestId = uuid();

    function aviso(txt, tono) {
      if (!estado) return;
      estado.textContent = txt || '';
      estado.hidden = !txt;
      if (tono) estado.setAttribute('data-tono', tono); else estado.removeAttribute('data-tono');
    }

    Array.prototype.forEach.call(raiz.querySelectorAll('[data-mi-rf-estrellas]'), estrellas);

    /* --- 1. política y campos desde la app --------------------------------- */
    function aplicarPolitica() {
      var campos = (dto.formPolicy && dto.formPolicy.fields) || {};
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-mi-rf-campo]'), function (caja) {
        var clave = caja.getAttribute('data-mi-rf-campo');
        /* Sin política (DTO caído) manda lo que pintó Liquid: estrellas, correo y fotos opcionales. */
        var modo = campos[clave] || (clave === 'rating' || clave === 'email' || clave === 'photos' ? 'optional' : 'hidden');
        if ((clave === 'photos' || clave === 'video' || clave === 'audio' || clave === 'beforeAfter' || clave === 'audioTranscript') && !dto.media) modo = 'hidden';
        var oculto = modo === 'hidden';
        caja.hidden = oculto;
        Array.prototype.forEach.call(caja.querySelectorAll('input, textarea, select'), function (el) {
          el.disabled = oculto;
          if (el.type !== 'hidden' && el.type !== 'radio' && el.type !== 'checkbox' && el.type !== 'file') el.required = !oculto && modo === 'required';
        });
        var req = caja.querySelector('[data-mi-rf-req]');
        if (req) req.hidden = modo !== 'required';
        caja.setAttribute('data-mi-rf-modo', modo);
      });
      if (extras && dto.fields) {
        extras.innerHTML = dto.fields.filter(function (f) { return f.showOnForm !== false; }).map(campoExtra).join('');
        Array.prototype.forEach.call(extras.querySelectorAll('[data-mi-rf-estrellas]'), estrellas);
      }
      /* Cada acordeón existe solo si tiene algo visible dentro (campo de la
         política o campo personalizado) y se abre solo si algo es obligatorio. */
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-mi-rf-mas]'), function (mas) {
        var visibles = mas.querySelectorAll('[data-mi-rf-campo]:not([hidden]), [data-mi-rf-extra], .mi-rf__extras > *');
        mas.hidden = visibles.length === 0;
        if (mas.querySelector('[data-mi-rf-modo="required"], [data-mi-rf-requerido="1"], [required]:not([disabled])')) mas.open = true;
      });
      /* El consentimiento de medios existe en cuanto hay algún campo de archivo visible. */
      if (consent) consent.hidden = !raiz.querySelector('input[type="file"]:not([disabled])');
    }

    var cargando = false;
    function cargar() {
      if (cargando || dto.formPolicy) return;
      cargando = true;
      fetch(base + '/list?product_id=' + encodeURIComponent(raiz.getAttribute('data-product-id') || '') + '&page=1&per_page=1', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.status === 402 || r.status === 401 || r.status === 404) throw new Error('apagado');
        if (!r.ok) throw new Error('http_' + r.status);
        return r.json();
      })
      .then(function (p) {
        if (!p || p.ok !== true || !p.settings || p.settings.collectReviews === false) throw new Error('apagado');
        dto.fields = p.fields || [];
        dto.formPolicy = p.formPolicy || null;
        dto.fieldVersion = typeof p.fieldVersion === 'string' ? p.fieldVersion : '';
        dto.formPolicyVersion = typeof p.formPolicyVersion === 'string' ? p.formPolicyVersion : '';
        dto.media = p.settings.mediaUploadsEnabled === true;
        aplicarPolitica();
        raiz.setAttribute('data-mi-rf-estado', 'listo');
      })
      .catch(function (e) {
        var motivo = e && e.message ? e.message : 'error';
        raiz.setAttribute('data-mi-rf-motivo', motivo);
        /* La app dice que NO recoge (401/402/404/collectReviews=false): los
           botones desaparecen en vez de abrir un formulario que va a rechazar.
           Un 5xx o un corte de red es otra cosa: el servicio existe y el
           envío puede funcionar al pulsar; queda el formulario base (nombre,
           nota, texto) sin los campos extra, que sí exigen el DTO. */
        if (motivo === 'apagado') {
          raiz.setAttribute('data-mi-rf-estado', 'apagado');
          if (seccion.setAttribute) seccion.setAttribute('data-mi-rf-disponible', 'no');
          cerrar();
          return;
        }
        aplicarPolitica();
        raiz.setAttribute('data-mi-rf-estado', 'listo-sin-dto');
      })
      .then(function () { cargando = false; });
    }
    cargar();

    /* --- 2. fotos: selección local, previsualización, sin subir hasta enviar -- */
    function pintarPrevias() {
      if (!previas) return;
      previas.querySelectorAll('img').forEach(function (img) { URL.revokeObjectURL(img.src); });
      previas.innerHTML = fotos.map(function (f, i) { return '<span class="mi-rf__previa"><img src="' + URL.createObjectURL(f) + '" alt=""><button type="button" class="mi-rf__previa-quitar" data-mi-rf-quitar="' + i + '" aria-label="Quitar foto">×</button></span>'; }).join('');

    }
    if (fotosInput) {
      fotosInput.addEventListener('change', function () {
        var nuevas = Array.prototype.slice.call(fotosInput.files || []);
        var malas = nuevas.filter(function (f) { return ['image/jpeg', 'image/png', 'image/webp'].indexOf(f.type) === -1 || f.size <= 0 || f.size > MAX_FOTO_BYTES; });
        if (malas.length) { aviso('Revisa las fotos: JPG, PNG o WebP de máximo 5 MB cada una.', 'error'); fotosInput.value = ''; return; }
        fotos = fotos.concat(nuevas).slice(0, MAX_FOTOS);
        if (fotos.length === MAX_FOTOS && nuevas.length + (fotos.length - nuevas.length) > MAX_FOTOS) aviso('Se toman las 3 primeras fotos.');
        else aviso('');
        fotosInput.value = '';
        pintarPrevias();
      });
      previas.addEventListener('click', function (e) {
        var b = e.target.closest('[data-mi-rf-quitar]');
        if (!b) return;
        fotos.splice(+b.getAttribute('data-mi-rf-quitar'), 1);
        pintarPrevias();
      });
    }

    Array.prototype.forEach.call(raiz.querySelectorAll('[data-mi-rf-archivo]'), function (input) {
      var clave = input.getAttribute('data-mi-rf-archivo');
      var etq = raiz.querySelector('[data-mi-rf-nombre-' + clave + ']');
      var base = etq ? etq.textContent : '';
      var tipos = (input.getAttribute('data-mi-rf-tipos') || '').split(',');
      var max = +input.getAttribute('data-mi-rf-max') || Infinity;
      input.addEventListener('change', function () {
        var f = input.files && input.files[0];
        var caja = input.closest('.mi-rf__adjuntar');
        if (!f) { if (etq) etq.textContent = base; if (caja) caja.classList.remove('esta-cargado'); return; }
        if (tipos.indexOf(f.type) === -1 || f.size <= 0 || f.size > max) {
          input.value = '';
          aviso('Revisa el archivo: ' + base, 'error');
          return;
        }
        aviso('');
        if (etq) etq.textContent = f.name;
        if (caja) caja.classList.add('esta-cargado');
      });
    });
    /* --- 3. envío -------------------------------------------------------------- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      aviso('');
      var nota = form.querySelector('input[name="rating"]');
      var cajaNota = raiz.querySelector('[data-mi-rf-campo="rating"]');
      if (cajaNota && cajaNota.getAttribute('data-mi-rf-modo') === 'required' && !nota.value) {
        aviso('Elige una calificación de 1 a 5 estrellas.', 'error');
        var primera = cajaNota.querySelector('.mi-rf__estrella'); if (primera) primera.focus();
        return;
      }
      var extraVacio = extras && Array.prototype.find.call(extras.querySelectorAll('[data-mi-rf-extra][data-mi-rf-requerido="1"]'), function (x) { return !x.querySelector('input[type="hidden"]').value; });
      if (extraVacio) { aviso('Falta una respuesta en «' + extraVacio.querySelector('.mi-rf__etq').textContent.replace('*', '').trim() + '».', 'error'); return; }
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var hayArchivos = fotos.length > 0 || Array.prototype.some.call(raiz.querySelectorAll('[data-mi-rf-archivo]'), function (i) { return i.files && i.files[0]; });
      var check = consent && consent.querySelector('input');
      if (hayArchivos && check && !check.checked) { aviso('Marca la autorización para publicar tus archivos.', 'error'); check.focus(); return; }

      var fd = new FormData(form);
      fd.delete('photos');
      fotos.forEach(function (f) { fd.append('photos', f, f.name); });
      if (!hayArchivos) fd.delete('mediaPublicationConsent');
      if (dto.fieldVersion) fd.set('fieldVersion', dto.fieldVersion);
      if (dto.formPolicyVersion) fd.set('formPolicyVersion', dto.formPolicyVersion);
      fd.set('requestId', requestId);
      fd.set('productGid', raiz.getAttribute('data-product-gid') || '');
      fd.set('productHandle', raiz.getAttribute('data-product-handle') || '');
      fd.set('productTitle', raiz.getAttribute('data-product-title') || '');

      enviar.disabled = true;
      fetch(base + '/submit', { method: 'POST', body: fd })
        .then(function (r) { return r.json().then(function (j) { return { res: r, j: j }; }, function () { return { res: r, j: null }; }); })
        .then(function (out) {
          enviar.disabled = false;
          if (out.j && out.j.ok) {
            form.hidden = true;
            var intro = raiz.querySelector('.mi-rf__intro'); if (intro) intro.hidden = true;
            var exito = raiz.querySelector('[data-mi-rf-exito]');
            if (exito) {
              exito.hidden = false;
              if (out.j.status === 'approved') { var t = exito.querySelector('[data-mi-rf-exito-txt]'); if (t) t.textContent = 'Tu reseña ya está publicada.'; }
              var cerrarBtn = exito.querySelector('[data-mi-rf-cerrar]'); if (cerrarBtn) cerrarBtn.focus({ preventScroll: true });
            }
            raiz.setAttribute('data-mi-rf-estado', 'enviado');
            raiz.dispatchEvent(new CustomEvent('mi:resena:enviada', { bubbles: true, detail: { status: out.j.status } }));
            return;
          }
          var err = (out.j && out.j.error) || '';
          var msg = out.res.status === 429 ? 'Demasiados intentos. Espera un momento e inténtalo de nuevo.'
            : out.res.status === 402 ? 'La tienda no recibe reseñas por ahora.'
            : err === 'delivery_required' ? 'La tienda recibe reseñas después de la entrega. Inicia sesión con la cuenta de tu compra.'
            : err === 'verification_unavailable' ? 'No pudimos comprobar la entrega ahora. Inténtalo más tarde.'
            : /file_too_large|request_too_large|too_many_photos|unsupported_image/.test(err) ? 'Revisa las fotos: máximo 3 archivos JPG, PNG o WebP de 5 MB.'
            : err === 'review_media_permission_required' ? 'La tienda todavía no habilitó la carga de fotos. Envía la reseña sin fotos.'
            : out.j && out.j.errors ? 'Revisa los campos marcados: ' + Object.keys(out.j.errors).join(', ') + '.'
            : 'No se pudo enviar. Inténtalo de nuevo.';
          aviso(msg, 'error');
          /* El requestId es por INTENTO: si el servidor lo rechazó, el siguiente
             intento lleva contenido nuevo y un id nuevo. */
          requestId = uuid();
        })
        .catch(function () { enviar.disabled = false; aviso('Sin conexión. Inténtalo de nuevo.', 'error'); });
    });
  }

  function arrancar() { Array.prototype.forEach.call(document.querySelectorAll('[data-mi-rf]'), montar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector('[data-mi-rf]'); if (r) montar(r); });
})();
